import { render, staticRenderFns } from "./PCheckboxDropdown.vue?vue&type=template&id=b08b760e&scoped=true&"
import script from "./PCheckboxDropdown.vue?vue&type=script&lang=ts&"
export * from "./PCheckboxDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./PCheckboxDropdown.vue?vue&type=style&index=0&id=b08b760e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08b760e",
  null
  
)

export default component.exports